var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-frame"},[_c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-photo"}),_c('div',{staticClass:"empty-text"},[_vm._v("啊哦，这里好像什么都没有")])])])
}]

export { render, staticRenderFns }